import Collection from "./Collection";
import Domain from "./Domain";
import Item from "./Item";

export default {
  Domain,
  Collection,
  Item,
};
